import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { getAllReportsData } from "../../../utils/apis/Canceled/Canceled";
import { formatDate, IDS } from "../../../utils/common";
import Pagination from "../../common/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import FilterOffcanvas from "../../common/common-offcanvas/Filter_offcanvas";
import { Permission } from "../../../utils/permissions";

const Reports = ({
  isAllow,
  status,
  setStatus,
  handleExportCSV,
  handlePrint,
  handleExportExcel,
  convertrate,
}) => {
  const { register, reset, setValue, control, getValues } = useForm();


  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [TotalEntries, setTotalEntries] = useState(1);
  const [TotalPages, setTotalPages] = useState(1);
  const [perPage, setperPage] = useState(10);

  const getData = async (search = "") => {
    const res = await getAllReportsData(
      currentPage,
      perPage,
      getValues("contact"),
      getValues("name"),
      getValues("from"),
      getValues("to"),
      getValues("state_id")?.value,
      getValues("city_id")?.value,
      getValues("type")?.value,
    );

    setData(res.data);
    setCurrentPage(res?.data?.currentPage);
    setperPage(res?.data?.per_page);
    setTotalEntries(res?.data?.totalEntries);
    setTotalPages(res?.data?.totalPages);
  };

  useEffect(() => {
    getData(search);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perPage, currentPage, status]);

  const [search] = useState({
    name: "",
    serviceNo: "",
  });

  const [modalShow2, setModalShow2] = React.useState(false);

  return (
    <div className="search-investor mt-4">
      <p className="sub">Report</p>
      {isAllow?.includes(Permission.OutwardPayment.ReportDownload.name) ? (
        <div className="inward-payment">
          <div className="nav-link active">
            <div className="dt-buttons btn-group flex-wrap">
              <button
                className="btn btn-secondary buttons-excel buttons-html5 ml-1 Excel_btn"
                tabindex="0"
                type="button"
                onClick={() => handleExportExcel(data, "Report")}
              >
                <span>Excel</span>
              </button>
              <button
                className="btn btn-secondary buttons-csv buttons-html5 CSV_btn"
                tabindex="0"
                type="button"
                onClick={() => handleExportCSV(data, "Report")}
              >
                <span>CSV</span>
              </button>
              <button
                className="btn btn-secondary buttons-print Print_btn"
                tabindex="0"
                type="button"
                onClick={() => handlePrint(data, "Report")}
              >
                <span>Print</span>
              </button>

              <input
                type="number"
                className="ps-3"
                onChange={(e) => setperPage(e.target.value)}
                placeholder="Enter Per Page Data"
              ></input>
            </div>
          </div>

          <div className="filterdiv">
            <button onClick={() => setModalShow2(true)} className="filterbtn">
              <FontAwesomeIcon icon={faFilter} />
              &nbsp;Filter
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* table started */}
      <div className="table-main">
        <div className="table-responsive mt-2">
          <table className="table table-bordered  table-striped">
            <thead>
              <tr>
                <th className="name">
                  Payment Date
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Investor Name
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Service No
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  State
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  District
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  A/C No
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  IFSC Code
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Withdrawal Amount
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Bank Charges
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Payment Type
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                {/* <th className="name">
                  Total Amount
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th> */}
                <th className="name">
                  Withdraw Status
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>{" "}
                <th className="name">
                  Customer Cancel Status
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.map((data, index) => (
                <tr className="odd" key={index}>
                  <td>{formatDate(data?.createdAt)}</td>
                  <td>
                    {data?.user?.f_name} {data?.user?.l_name}
                  </td>
                  <td>{data?.user?.contact_no}</td>
                  <td>{data?.user?.users_detail?.state?.name}</td>
                  <td>{data?.user?.users_detail?.city?.name}</td>
                  <td>{data?.ac_no}</td>
                  <td>{data?.ifsc_code}</td>
                  <td>{convertrate(data?.amount)}</td>
                  <td>{convertrate(data?.bank_charges)}</td>
                  <td>{data?.withdrawn_type}</td>
                  <td>
                    {data?.accepted_rejected === null
                      ? ""
                      : data?.accepted_rejected
                        ? "Accepted"
                        : "Rejected"}
                  </td>
                  <td>{IDS.customer_status[data?.customer_status]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* table ended */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        TotalPages={TotalPages}
        TotalEntries={TotalEntries}
        perPage={perPage}
      />

      {["end"].map((placement, idx) => (
        <FilterOffcanvas
          placement={placement}
          key={idx}
          show={modalShow2}
          onHide={() => setModalShow2(false)}
          setValue={setValue}
          getValues={getValues}
          getData={getData}
          register={register}
          reset={reset}
          control={control}
        />
      ))}
    </div>
  );
};

export default Reports;
